import React, { useEffect, useState } from "react"
import MetaTags from "react-meta-tags"
import { withRouter, Link } from "react-router-dom"
import { connect } from "react-redux"
import {
  Container,
  Row,
  Col,
  Button,
  Card,
  CardBody,
  Label,
  Badge,
  Input,
  Table,
} from "reactstrap"
import Select from "react-select"
import { useSelector } from "react-redux"
import PropTypes from "prop-types"
import { ReactSearchAutocomplete } from "react-search-autocomplete"
import { isEmpty } from "lodash"
import moment from "moment"
import ButtonSpinner from "../../components/ButtonSpinner"
//Import Styles
import "./styles.scss"
//Data Table packeages
import BootstrapTable from "react-bootstrap-table-next"
import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
  SizePerPageDropdownStandalone,
  PaginationTotalStandalone,
} from "react-bootstrap-table2-paginator"
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit"
import { CSVExport } from "react-bootstrap-table2-toolkit"
import Modal from "react-bootstrap/Modal"
// import Multiselect from "multiselect-react-dropdown"
import * as permissionAction from "../../store/cGVybWlzc2lvbg/actions"
//components
import Breadcrumbs from "../../components/Common/Breadcrumb"
import * as freelancerReportAction from "../../store/ZnJlZWxhbmNlclJlcG9ydA/actions"
import * as manageEcAction from "../../store/TWFuYWdlRWM/actions"
import * as subFreelancerAction from "../../store/c3ViZnJlZWxhbmNlcg/actions"
import * as teamSchedulingAction from "../../store/ZWNUZWFtU2NoZWR1bGl/actions"

const FreelancerReport = (props) => {
  const { SearchBar } = Search
  //title
  const title = "Freelancer Report"
  const { dispatch, searchBarStyle } = props

  useEffect(() => {
    dispatch(freelancerReportAction.loadRecordsMetaData())
    dispatch(permissionAction.loadEmployee())
    dispatch(
      freelancerReportAction.loadFreelancerReport({
        isManageEC: true,
      })
    )
    // dispatch(
    //   teamSchedulingAction.loadFreelancerList({
    //     status: "active",
    //     type: "single",
    //   })
    // )
    dispatch(subFreelancerAction.loadRecords())
    setFreelancerList([])
    setFreelancerData({
      amount: "",
    })
  }, [])

  //State reducer section

  const manageEcUpdate = useSelector((state) => state.freelancerReport)
  const update = useSelector((state) => state.teamScheduling)
  const freelanceUpdate = useSelector(
    (specificstate) => specificstate.subfreelancer
  )
  const { freelancer_details = [] } = update
  const { freelancerMetaData = {}, freelancer_report = [] } = manageEcUpdate

  const { records = [] } = freelanceUpdate
  const employeeUpdate = useSelector(
    (specificstate) => specificstate.permissionrequest
  )

  const { employee_list = [] } = employeeUpdate
  const sessionUpdate = useSelector((specificstate) => specificstate.session)

  const { user = [] } = sessionUpdate

  console.log(user, "user details from session")
  console.log(records, "records details")

  //Date format
  const dateSetting =
    !isEmpty(user) && user.setting && user.setting.dateFormate
      ? user.setting.dateFormate.toUpperCase()
      : []

  const dateFormate = !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

  //manage Ec initial state
  const [freelancerData, setFreelancerData] = useState({
    company: [],
    branch: [],
    department: [],
    fromDate: "",
    serviceId: "",
    toDate: "",
    amount: "",
    subAmount: "",
  })

  //filter table change

  //handle change
  const handleChange = async (e) => {
   // setFreelancerData({ ...freelancerData, [e.target.name]: e.target.value })
   setFreelancerData({ ...freelancerData, [e.target.name]: e.target.value.toString() })
  }

  //dropdown initial state
  const [companies, setCompanies] = useState([])
  const [branches, setBranches] = useState([])
  const [events, setEvents] = useState([])
  const [salesAgent, setSalesAgent] = useState([])
  const [freelancerList, setFreelancerList] = useState([])
  const [subFreelancerList, setSubFreelancerList] = useState([])
  const [searchValueList, setSearchValueList] = useState({})
  console.log(searchValueList, "searchValueList")

  const searchValue = !isEmpty(searchValueList)
    ? searchValueList
    : {
        isManageEC: true,
      }
  //Updatefreelancer section
  const [freelancerModal, setFreelancerModal] = useState(false)
  const handleFreelancerModal = () => setFreelancerModal(false)
  const [freelancerServiceDetails, setFreelancerServiceDetails] = useState("")
  const [isHead, setIsHead] = useState("")
  const [freelanceSubShooterId, setFreelanceSubShooterId] = useState("")

  console.log(freelancerServiceDetails, "freelancerServiceDetails")
  const handleFreelanceChange = (e) => {
    setFreelancerList(e)
    const listData = freelancerData
    setIsHead(false)
    setSubFreelancerList([])
    setFreelanceSubShooterId("")
    const freelanceAmountArray = e ? e.paymentDetails : []
    console.log(freelanceAmountArray, "freelanceAmountArray")
    const freelanceAmountData =
      !isEmpty(freelanceAmountArray) && freelanceAmountArray.length > 0
        ? freelanceAmountArray.find(
            (data) => data.serviceName == freelancerServiceDetails.serviceName
          )
        : ""

    console.log(freelanceAmountData, "freelanceAmountData")

    freelancerData.amount =
      e && !isEmpty(freelanceAmountData)
        ? freelanceAmountData.costPerSession
        : 0
    setFreelancerData(listData)
  }
  const handleSubFreelanceChange = (e) => {
    setSubFreelancerList(e)
    const listData = freelancerData
    const freelanceAmountArray = e ? e.paymentDetails : []
    console.log(freelanceAmountArray, "freelanceAmountArray")
    const freelanceAmountData =
      !isEmpty(freelanceAmountArray) && freelanceAmountArray.length > 0
        ? freelanceAmountArray.find(
            (data) => data.serviceName == freelancerServiceDetails.serviceName
          )
        : ""
    freelancerData.subAmount =
      e && !isEmpty(freelanceAmountData)
        ? freelanceAmountData.costPerSession
        : 0
    setFreelancerData(listData)
  }

  console.log(subFreelancerList, "subFreelancerList")

  const [resetManager, setResetManager] = useState(false)
  //reset functionalities
  const resetForm = () => {
    setCompanies([])
    setBranches([])
    setEvents([])
    setSalesAgent([])
    setSearchValueList([])
    setFreelancerData({
      fromDate: "",
      toDate: "",
      amount: "",
      subAmount: "",
    })
    setResetManager(true)
    setTimeout(() => {
      setResetManager(false)
    }, 0)
    dispatch(
      freelancerReportAction.loadFreelancerReport({
        isManageEC: true,
      })
    )
  }

  //button spinner state
  const [btnLoader, setBtnLoader] = useState(false)

  //clearance modal
  const [clearanceModal, setClearanceModal] = useState(false)

  //dropdown options

  const company =
    !isEmpty(companies) && companies.map((company) => company.value)
  const branch = !isEmpty(branches) && branches.map((branch) => branch.value)

  const branchOptions =
    !isEmpty(freelancerMetaData) &&
    freelancerMetaData.branchOptions.filter(
      (branch) =>
        branch.companyId ===
        companies.map((company) => company.value).toString()
    )

  // Freelancer list options
  const freelancerOptions =
    freelancer_details && freelancer_details && freelancer_details.length > 0
      ? freelancer_details.map((e) =>
          Object.assign(
            {},
            {
              label: e.freelancerName,
              value: e._id,
              freelancerCode: e.freelancerCode,
              paymentDetails: e.serviceDetail,
              vendorMembers: e.vendorDetail,
              vendorType: e.vendorType,
            }
          )
        )
      : []

  console.log(freelancerOptions, "freelancerOptions")

  const subFreelancerListData =
    !isEmpty(records) && records.length > 0
      ? records.map((data) => {
          if (freelancerList.value === data.freelancerId)
            return {
              _id: data._id,
              name: data.name,
              paymentDetails: data.paymentDetails,
            }
        })
      : []
  const subFreelancerData = !isEmpty(subFreelancerListData)
    ? subFreelancerListData.filter((data) => data !== undefined)
    : []
  const createFreelanceOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        let obj = {}
        obj.value = element._id
        obj.label = element.name
        obj.paymentDetails = element.paymentDetails

        options.push(obj)
      })
    return options
  }
  const subFreelancerListOptions = createFreelanceOptions(subFreelancerData)

  console.log(freelancerList, "freelancerList")
  console.log(subFreelancerList, "subFreelancerList")
  console.log(subFreelancerListOptions, "subFreelancerListOptions")

  //employee options(agent options)

  const employeeList =
    !isEmpty(employee_list) &&
    employee_list.map((employee) => {
      return {
        _id: employee._id,
        empCode: employee.empCode,
        name: employee.name,
        companyId: employee.companyId,
        roleId: employee.roleId,
      }
    })
  console.log(employee_list, "employeeee")
  const createOptions = (array) => {
    const options = []
    !isEmpty(array) &&
      array.forEach((element) => {
        const labelEmployee = element.empCode.concat(" - ", element.name)
        // [...element.empCode,...element.name].join('')

        let obj = {}
        obj.value = element._id
        obj.label = labelEmployee
        obj.empCode = element.empCode
        obj.companyId = element.companyId
        obj.roleId = element.roleId
        options.push(obj)
      })
    return options
  }

  const ecagentOptions = createOptions(employeeList)

  //fuse options for venue(autocomplete field)
  const fuseOptions = {
    keys: ["empCode", "label"],
  }

  //apply filter submit

  const applyFilter = (e) => {
    e.preventDefault()
    var searchCompany = companies && companies ? company : ""
    var searchBranch = branches && branches ? branch : ""
    var searchEvent = events && events ? events.value : ""
    var searchAgent = salesAgent && salesAgent ? salesAgent.value : ""

    var searchFromDate =
      freelancerData && freelancerData.fromDate
        ? moment(freelancerData.fromDate).format("YYYY-MM-DD")
        : ""
    var searchToDate =
      freelancerData && freelancerData.toDate
        ? moment(freelancerData.toDate).format("YYYY-MM-DD")
        : ""

    var searchvalue = {}
    searchvalue.isManageEC = true
    if (searchCompany) {
      searchvalue.companyId = searchCompany
    }
    if (searchAgent) {
      searchvalue.employeeId = searchAgent
    }
    if (searchBranch) {
      searchvalue.branchId = searchBranch
    }
    if (searchEvent) {
      searchvalue.eventId = searchEvent
    }

    if (searchFromDate) {
      searchvalue.eventFromDate = searchFromDate
    }
    if (searchToDate) {
      searchvalue.eventToDate = searchToDate
    }
    console.log(searchvalue, "searchvalue")
    setSearchValueList(searchvalue)
    dispatch(freelancerReportAction.loadFreelancerReport(searchvalue))
    setBtnLoader(true)
    setTimeout(() => {
      setBtnLoader(false)
    }, 2000)
  }

  //lead id
  // const [leadId, setLeadId] = useState("")
  // console.log(leadId, "leadId")
  //data table for manageEc

  console.log(freelancerMetaData, "freelancerMetaData")
  console.log(freelancerData, "freelancerData")

  let slNo = 0
  const freelancerDataTable = !isEmpty(freelancer_report)
    ? freelancer_report.map((freelancerData, index) => {
        slNo = slNo + 1

        // const dateFormate =
        //   !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

        const leadDate = freelancerData.leadDate
          ? moment(freelancerData.leadDate)
              .subtract(5, "hours")
              .subtract(30, "minutes")
              .format(`${dateFormate} hh:mm A`)
          : []

        const eventCount =
          !isEmpty(freelancerData) &&
          freelancerData.teamScheduleServiceDetails.length > 0
            ? freelancerData.teamScheduleServiceDetails.length
            : 0

        const colorCode =
          !isEmpty(freelancerMetaData) &&
          freelancerMetaData.processStatusOptions &&
          freelancerMetaData.processStatusOptions.length > 0
            ? freelancerMetaData.processStatusOptions.find(
                (_) => _.processStatusId === freelancerData.ecProcessStatus
              ) &&
              freelancerMetaData.processStatusOptions.find(
                (_) => _.processStatusId === freelancerData.ecProcessStatus
              ).colorCode
            : ""

        console.log(colorCode, "colorCode")
        console.log(freelancerData.ecProcessStatus, "ecProcessStatus")
        return {
          _id: freelancerData._id,
          sNo: slNo,
          leadno: freelancerData.leadNo,
          routeData: freelancerData,
          branchId: freelancerData.branchId,
          branchName: freelancerData.branchName,
          groomName: freelancerData.groomName,
          brideName: freelancerData.brideName,
          clientName: !isEmpty(freelancerData.clientDetails)
            ? freelancerData.clientDetails.firstName +
              " " +
              freelancerData.clientDetails.lastName
            : "",
          companyId: freelancerData.companyId,
          companyName: freelancerData.companyName,
          leadServiceName: freelancerData.leadServiceName,
          leadSourceName: freelancerData.leadSourceName,
          leadType: freelancerData.leadType,
          salesUrge: freelancerData.salesUrge,
          clientDetails: freelancerData.clientDetails,
          colorCode: !isEmpty(colorCode) ? colorCode : "",
          overallStatus: !isEmpty(freelancerData.overAllStatus)
            ? freelancerData.overAllStatus
            : "--",
          allowOrderData: freelancerData.isAllowOrder,
          allowOrder: freelancerData.isAllowOrder === true ? "YES" : "NO",
          eventDetails: freelancerData.events,
          clientCode: !isEmpty(freelancerData.clientDetails)
            ? freelancerData.clientDetails.clientNo
            : "",
          teamScheduleCount: eventCount,
          teamScheduleDetails: freelancerData.teamScheduleServiceDetails,
          ecAssign: isEmpty(freelancerData.ecPrcessStatusName)
            ? "Unassigned"
            : "Assigned",
          assignedEcName: !isEmpty(freelancerData.leadECAssign)
            ? freelancerData.leadECAssign.assignedToName
            : "",
          leadDate: leadDate,
          ecProcessStatus: freelancerData.ecProcessStatus,
          teamScheduleId: freelancerData.teamScheduleId,
          ecProcessStatusName: freelancerData.ecPrcessStatusName,
          ecStatus:
            freelancerData.ecProcessStatus !== "PS2"
              ? freelancerData.ecPrcessStatusName
              : "--",
          status: freelancerData.status,
          clearanceStatus: (
            <Badge
              color={
                freelancerData.ecProcessStatus === "PS21" ? "success" : "danger"
              }
              style={{ padding: "6px" }}
            >
              Clearance
            </Badge>
          ),
          leadStatus: (
            <Badge
              color={
                freelancerData.leadAssign.leadStatus === "PS2"
                  ? "success"
                  : "danger"
              }
              style={{ padding: "6px" }}
            >
              {" "}
              {!isEmpty(freelancerData) &&
              freelancerData.leadAssign.leadStatus === "PS2"
                ? "Assigned"
                : "Unassigned"}
            </Badge>
          ),
          key: index,
          isAssigned: freelancerData.isAssigned,
        }
      })
    : []

  console.log(freelancerDataTable, "freelancerDataTable")
  //download feature in data table
  const { ExportCSVButton } = CSVExport

  //columns for data table
  const columns = [
    {
      dataField: "sNo",
      text: "S.No",
    },
    {
      dataField: "leadno",
      text: "Lead No",
      sort: true,
      formatter: (cellContent, row) => {
        const leadData = row.routeData
        return (
          <>
            {" "}
            <Link
              to={{
                pathname: `/client-details/${row._id}`,
                state: {
                  row: leadData,
                  mode: "EC",
                  leadClientId: leadData,
                  menuName: "FreelancerReport",
                },
              }}
            >
              <span>{row.leadno}</span>
            </Link>
          </>
        )
      },
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "120px",
      },
    },
    {
      dataField: "companyName",
      text: "Company Name",
      sort: true,
      headerStyle: {
        minWidth: "156px",
      },
    },
    {
      dataField: "branchName",
      text: "Branch Name",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "138px",
      },
    },
    {
      dataField: "clientCode",
      text: "Client Code",
      sort: true,
      style: {
        color: "#e40d8c",
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "126px",
      },
    },
    {
      dataField: "clientName",
      text: "Client Name ",
      sort: true,
      style: {
        textTransform: "uppercase",
      },
      headerStyle: {
        minWidth: "150px",
      },
    },
    {
      dataField: "brideName",
      text: "Bride Name ",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "groomName",
      text: "Groom Name ",
      sort: true,
      headerStyle: {
        minWidth: "140px",
      },
    },
    {
      dataField: "leadDate",
      text: "Lead Date",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "assignedEcName",
      text: "Ec Agent Name",
      sort: true,
      headerStyle: {
        minWidth: "165px",
      },
    },
    {
      dataField: "teamScheduleCount",
      text: "No of Freelancers",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <div className="space-between">
            <span className="badge rounded-pill bg-primary">
              {row.teamScheduleCount}
            </span>
          </div>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
    {
      dataField: "status",
      text: "Status",
      sort: true,
      formatter: (cellContent, row) => {
        return (
          <>
            <Badge
              color={
                !isEmpty(row) && row.isAssigned === "Yes" ? "success" : "danger"
              }
              style={{ padding: "8px", fontSize: "12px" }}
            >
              {!isEmpty(row) && row.isAssigned === "Yes"
                ? "Completed"
                : "Not Completed"}
            </Badge>
          </>
        )
      },
      headerStyle: {
        minWidth: "160px",
      },
    },
  ]

  // pagination options
  const options = {
    sizePerPage: 50,
    totalSize: freelancer_report.length, // replace later with size(customers),
    custom: true,
    pageStartIndex: 1,
    firstPageText: "First",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
  }

  //expand row functionality from bootstrap table

  const expandRow = {
    renderer: (row) => (
      <>
        <Table bordered>
          <thead>
            <tr>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event No
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Event Date
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Service Name
              </th>
              <th style={{ backgroundColor: "#e40d8c", color: "#ffffff" }}>
                Freelancer Name
              </th>
            </tr>
          </thead>
          <tbody>
            {row && row.teamScheduleDetails.length > 0 ? (
              row.teamScheduleDetails.map((data) => {
                console.log(data, "row list data")

                const dateFormate =
                  !isEmpty(dateSetting) && dateSetting ? dateSetting : ""

                console.log(dateFormate, "dateFormate")
                const eventFromDate = moment(data.eventDate).format(
                  "YYYY-MM-DD"
                )
                console.log(eventFromDate, "eventFrom Date")

                if (
                  new Date(data.eventDate) >=
                    new Date(freelancerData.fromDate) &&
                  new Date(data.eventDate) <= new Date(freelancerData.toDate)
                ) {
                  const freelancerName =
                    !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                      ? data.teamFreelanceShooter.map(
                          (data) => data.freelancerMainShooterName
                        )
                      : ""
                  console.log(freelancerName, "freelancerName")

                  const freelanceNameArray =
                    !isEmpty(data) &&
                    !isEmpty(freelancerName) &&
                    freelancerName.length > 0
                      ? freelancerName[0]
                      : ""
                  return (
                    <tr key={data._id}>
                      <td>{!isEmpty(data.eventNo) ? data.eventNo : "--"}</td>
                      <td>
                        {!isEmpty(data.eventName) ? data.eventName : "--"}
                      </td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <td>
                        {!isEmpty(data.serviceName) ? data.serviceName : "--"}
                      </td>
                      <td>
                        <button
                          className="update-freelancer-btn"
                          style={{
                            background: freelanceNameArray ? "#17b77d" : "blue",
                          }}
                          onClick={() => {
                            setFreelancerServiceDetails(data)
                            setFreelancerModal(true)
                            dispatch(
                              teamSchedulingAction.loadFreelancerList({
                                status: "active",
                                serviceName: data.serviceName,
                              })
                            )
                            editFreelancerReport(data.teamFreelanceShooter)
                          }}
                        >
                          {!isEmpty(data) &&
                          !isEmpty(freelancerName) &&
                          !isEmpty(freelancerName[0])
                            ? freelancerName
                            : "Update"}
                        </button>
                      </td>
                    </tr>
                  )
                } else if (
                  isEmpty(freelancerData.fromDate) &&
                  isEmpty(freelancerData.toDate)
                ) {
                  const freelancerName =
                    !isEmpty(data) &&
                    data.teamFreelanceShooter &&
                    data.teamFreelanceShooter.length > 0
                      ? data.teamFreelanceShooter.map(
                          (data) => data.freelancerMainShooterName
                        )
                      : ""
                  console.log(freelancerName, "freelancerName")

                  const freelanceNameArray =
                    !isEmpty(data) &&
                    !isEmpty(freelancerName) &&
                    freelancerName.length > 0
                      ? freelancerName[0]
                      : ""
                  return (
                    <tr key={data._id}>
                      <td>{!isEmpty(data.eventNo) ? data.eventNo : "--"}</td>
                      <td>
                        {!isEmpty(data.eventName) ? data.eventName : "--"}
                      </td>
                      <td>{moment(data.eventDate).format(dateFormate)}</td>
                      <td>
                        {!isEmpty(data.serviceName) ? data.serviceName : "--"}
                      </td>
                      <td>
                        <button
                          className="update-freelancer-btn"
                          style={{
                            background: freelanceNameArray ? "#17b77d" : "blue",
                          }}
                          onClick={() => {
                            setFreelancerServiceDetails(data)
                            setFreelancerModal(true)
                            dispatch(
                              teamSchedulingAction.loadFreelancerList({
                                status: "active",
                                serviceName: data.serviceName,
                              })
                            )
                            editFreelancerReport(data.teamFreelanceShooter)
                          }}
                        >
                          {freelanceNameArray ? freelancerName : "Update"}
                        </button>
                      </td>
                    </tr>
                  )
                }
              })
            ) : (
              <tr key={0}>
                <td className="text-align-center" colSpan={5}>
                  No data found
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </>
    ),
    showExpandColumn: true,
    expandByColumnOnly: true,
    onlyOneExpanding: true,
  }

  //Edit freelancer report

  const editFreelancerReport = (data) => {
    console.log(data, "edit data")

    const freelancerNameData =
      !isEmpty(data) && data && data.length > 0 ? data.map((data) => data) : ""
    console.log(freelancerNameData, "edit freelancerNameData")

    const freelancerName =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].freelancerMainShooterName
        : []
    console.log(freelancerName, "freelancerName")
    const freelancerId =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].freelanceMainShooterId
        : []
    console.log(freelancerId, "freelancerId")
    const amount =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].amount
        : ""
    const isHead =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].isHead
        : ""
    const freelanceSubShooterId =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].freelanceSubShooterId
        : []
    const freelanceSubShooterName =
      !isEmpty(freelancerNameData) && freelancerNameData.length > 0
        ? freelancerNameData[0].freelancerSubShooterName
        : []
    console.log(freelanceSubShooterId, "freelanceSubShooterId")
    console.log(freelanceSubShooterName, "freelanceSubShooterName")
    console.log(amount, "amount")
    console.log(isHead, "isHead")
    const subFreelancerListData =
      !isEmpty(records) && records.length > 0
        ? records.find((data) => data.freelancerId === freelancerId)
        : []

    const subFreelanceAmount =
      !isEmpty(subFreelancerListData) &&
      subFreelancerListData.paymentDetails.length > 0
        ? subFreelancerListData.paymentDetails[0].costPerSession
        : ""
    console.log(subFreelanceAmount, "subFreelanceAmount")

    setFreelancerData({
      amount: amount,
      subAmount: subFreelanceAmount,
    })

    setIsHead(isHead)
    setFreelanceSubShooterId(freelanceSubShooterId)
    // set
    if (!isEmpty(freelancerId)) {
      setFreelancerList({
        label: freelancerName,
        value: freelancerId,
        vendorMembers: [],
      })
    }
    if (isHead === true) {
      setSubFreelancerList({
        label: freelanceSubShooterName,
        value: freelanceSubShooterId,
      })
    } else {
      setSubFreelancerList({
        label: "",
        value: "",
      })
    }
  }
  console.log(freelancerData.amount, "amount")
  console.log(freelancerList, "freelancerList")
  console.log(freelancerServiceDetails, "freelancerServiceDetails")
  //Update freelancer report
  const updateFreelancerDetails = () => {
    const updateFreelancer = {
      teamScheduleId: freelancerServiceDetails.teamScheduleId,
      teamServiceDetailId: freelancerServiceDetails.teamServiceDetailId,
      teamFreelanceShooter: [
        {
          freelanceMainShooterId: freelancerList.value,
          freelanceSubShooterId:
            freelancerList.vendorType === "single"
              ? ""
              : subFreelancerList.value,
          amount: !isEmpty(freelancerData.amount)
            ? parseFloat(freelancerData.amount)
            : 0,
          isHead: !isEmpty(subFreelancerList.value) ? true : false,
          isSelected: "1",
        },
      ],
    }
    dispatch(freelancerReportAction.updateFreelancerSchedule(updateFreelancer))
    setTimeout(() => {
      dispatch(freelancerReportAction.loadFreelancerReport(searchValue))
      setFreelancerModal(false)
      setFreelancerList([])
      setSubFreelancerList([])
    }, 1000)
  }

  //get today's date
  const current = new Date()
  const date = `${
    current.getMonth() + 1
  }-${current.getDate()}-${current.getFullYear()}`
  console.log(date, "today date")
  //empid
  const empId = localStorage.getItem("empId")
  console.log(empId, "my employee Id")

  const addClearance = () => {
    const applyClearance = {
      // leadId: leadId,
      mode: "LEVEL1",
      type: "Payment Clearance",
      clearanceDate: date,
      clearanceBy: empId,
      clearanceStatus: "PS21",
      remarks: "",
    }
    console.log(applyClearance, "applyClearance")
    dispatch(manageEcAction.addClearance(applyClearance))
    setTimeout(() => {
      dispatch(freelancerReportAction.loadFreelancerReport())
      setClearanceModal(false)
    }, 1000)
  }
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>{title} | Zero Gravity CRM</title>
        </MetaTags>
        <Container fluid>
          <Breadcrumbs title={"Event Coordination"} breadcrumbItem={title} />

          {/*form start */}
          <Row>
            <Col xs={12}>
              <Card>
                <CardBody>
                  <form>
                    <Row>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Company"}>
                            {"Company"}
                          </Label>
                        </div>

                        <Select
                          type="text"
                          name="companies"
                          isMulti
                          value={companies}
                          onChange={(e) => setCompanies(e)}
                          options={
                            freelancerMetaData
                              ? freelancerMetaData.companyOptions
                              : []
                          }
                          placeholder="Select Company"
                          classNamePrefix="select2-selection"
                          zIndex="2"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"} htmlFor={"Branch"}>
                            {"Branch"}
                          </Label>
                        </div>
                        <Select
                          type="text"
                          name="branches"
                          isMulti
                          value={branches}
                          onChange={(e) => setBranches(e)}
                          options={branchOptions}
                          placeholder="Select Branch"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Event"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="events"
                          value={events}
                          // isMulti
                          onChange={(e) => setEvents(e)}
                          options={
                            freelancerMetaData
                              ? freelancerMetaData.eventOptions
                              : []
                          }
                          placeholder="Select event"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"EC Agent"}</Label>
                        </div>
                        <ReactSearchAutocomplete
                          name="salesAgent"
                          key={resetManager}
                          items={ecagentOptions}
                          value={salesAgent}
                          type="autoComplete"
                          resultStringKeyName="label"
                          showIcon={false}
                          onSelect={(e) => setSalesAgent(e)}
                          onChange={(e) => setSalesAgent(e.target.value)}
                          placeholder="Enter EC Agent"
                          fuseOptions={fuseOptions} // Search on both fields
                          styling={{
                            height: "34px",
                            border: "1px solid #ced4da",
                            borderRadius: "4px",
                            backgroundColor: "white",
                            boxShadow: "none",
                            hoverBackgroundColor: "#E40D8C",
                            color: "black",
                            fontSize: "12px",
                            fontFamily: "Courier",
                            iconColor: "green",
                            clearIconMargin: "3px 8px 0 0",
                            zIndex: 10,
                          }}
                        />
                      </Col>
                      {/* <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>
                            {"Payment Status"}
                          </Label>
                        </div>
                        <Select
                          name="paymentStatus"
                          value={paymentStatus}
                          onChange={(e) => setPaymentStatus(e)}
                          classNamePrefix="select2-selection"
                          placeholder="Select Payment Status"
                          options={[
                            { label: "Paid", value: "paid" },
                            { label: "Un Paid", value: "unPaid" },
                          ]}
                        />
                      </Col> */}
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event From Date"}
                          >
                            {"Event From Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="fromDate"
                          value={freelancerData.fromDate}
                          max={freelancerData.toDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                      <Col lg="3" md="3" sm="12" xs="12" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label
                            className="form-label"
                            htmlFor={"Event To Date"}
                          >
                            {"Event To Date"}
                          </Label>
                        </div>
                        <Input
                          type="date"
                          placeholder="Select Date"
                          name="toDate"
                          value={freelancerData.toDate}
                          min={freelancerData.fromDate}
                          onChange={(e) => handleChange(e)}
                        />
                      </Col>
                    </Row>
                    <Row>
                      <Col lg="12" md="12" sm="12" xs="12" className="mt-3">
                        <div
                          className="filter-buttons"
                          style={{ float: "right" }}
                        >
                          <Button
                            type="button"
                            onClick={() => resetForm()}
                            className="btn btn-danger btn-label simple-form-Reset-btn"
                          >
                            <i className="bx bx-reset bx-flip-horizontal label-icon"></i>
                            Reset
                          </Button>
                          <Button
                            type="submit"
                            onClick={(e) => applyFilter(e)}
                            className="btn btn-success btn-label simple-form-applyfilter-btn mx-2"
                          >
                            <i className="bx bx-filter-alt label-icon"></i>
                            {btnLoader && btnLoader ? (
                              <ButtonSpinner />
                            ) : (
                              "Apply Filter"
                            )}{" "}
                          </Button>
                        </div>
                      </Col>
                    </Row>
                  </form>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Row>
            <Col md="12" lg="12" xl="12">
              <Card>
                <CardBody>
                  <PaginationProvider
                    pagination={paginationFactory(options)}
                    keyField="_id"
                    columns={columns}
                  >
                    {({ paginationProps, paginationTableProps }) => (
                      <ToolkitProvider
                        keyField="_id"
                        data={freelancerDataTable}
                        columns={columns}
                        search
                        exportCSV
                      >
                        {(props) => (
                          <div>
                            <Col md="12" xl="12" lg="12" sm="12" xs="12">
                              <Row className="d-flex flex-row  ">
                                <Col className="mb-3" md="4">
                                  <div className="d-flex flex-row ">
                                    <div className="search-box me-2 mb-2 d-inline-block d-flex flex-row ">
                                      <div
                                        className="position-relative mt-7"
                                        style={searchBarStyle || null}
                                      >
                                        <SearchBar {...props.searchProps} />
                                        <i className="bx bx-search-alt search-icon" />
                                      </div>
                                    </div>
                                  </div>{" "}
                                </Col>

                                <Col>
                                  <ExportCSVButton
                                    className="border float-right mx-10"
                                    style={{
                                      float: "right",
                                      backgroundColor: "#e40d8c",
                                      color: "#ffffff",
                                    }}
                                    {...props.csvProps}
                                  >
                                    Download{" "}
                                  </ExportCSVButton>{" "}
                                </Col>
                                <Col>
                                  <BootstrapTable
                                    {...props.baseProps}
                                    responsive
                                    keyField="_id"
                                    columns={columns}
                                    striped={true}
                                    bordered={true}
                                    expandRow={expandRow}
                                    {...paginationTableProps}
                                  />
                                </Col>
                              </Row>
                              <Row
                                style={{ marginTop: "5px" }}
                                className="align-items-md-center mt-30"
                              >
                                <Col className="inner-custom-pagination d-flex">
                                  <div className="d-inline d-flex flex-row">
                                    <SizePerPageDropdownStandalone
                                      {...paginationProps}
                                    />
                                    <div
                                      style={{
                                        fontSize: "14px",
                                        marginTop: "8px",
                                        marginLeft: "4px",
                                      }}
                                    >
                                      <PaginationTotalStandalone
                                        {...paginationProps}
                                      />
                                    </div>
                                  </div>
                                  <div
                                    className="text-md-right ms-auto"
                                    style={{ zIndex: 0 }}
                                  >
                                    <PaginationListStandalone
                                      {...paginationProps}
                                    />
                                  </div>
                                </Col>
                              </Row>
                            </Col>
                          </div>
                        )}
                      </ToolkitProvider>
                    )}
                  </PaginationProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {clearanceModal && (
            <Modal
              show={clearanceModal}
              size="md"
              style={{ backgroundColor: "#504e4ec9", opacity: 0.98 }}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Clearance Report</span>
                </div>
              </Modal.Header>
              <Modal.Body>Do You Want To Clearance The Report?</Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    type="submit"
                    onClick={() => {
                      setClearanceModal(false)
                      addClearance()
                    }}
                    style={{ marginLeft: "20px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Confirm
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
          {freelancerModal && (
            <Modal
              show={freelancerModal}
              size="md"
              onHide={handleFreelancerModal}
            >
              <Modal.Header
                style={{
                  backgroundColor: "#E40D8C",
                  color: "white",
                  minHeight: "65px",
                  fontSize: "16px",
                  fontWeight: "600",
                }}
              >
                <div className="d-flex flex-row">
                  <span>Update Freelancer</span>
                </div>
              </Modal.Header>
              <Modal.Body>
                <Row>
                  <div className="d-flex flex-column">
                    <div className="d-flex flex-row">
                      <Col lg="5" md="5" sm="10" xs="10" className="mt-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Freelancer"}</Label>
                        </div>
                        <Select
                          type="text"
                          name="freelancerList"
                          value={freelancerList}
                          // isMulti
                          onChange={(e) => handleFreelanceChange(e)}
                          options={freelancerOptions ? freelancerOptions : []}
                          placeholder="Select Freelancer"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                      <Col lg="5" md="5" sm="10" xs="10" className="mt-3 mx-3">
                        <div className="d-flex justify-content-between">
                          <Label className={"form-label"}>{"Amount"}</Label>
                        </div>
                        <Input
                          type="text"
                          name="amount"
                          value={freelancerData.amount}
                          // isMulti
                          onChange={(e) => handleChange(e)}
                          placeholder="Enter Amount"
                          classNamePrefix="select2-selection"
                        />
                      </Col>
                    </div>
                    {(!isEmpty(freelancerList.vendorType) &&
                      freelancerList.vendorType !== "single") ||
                    (freelancerList &&
                      freelancerList.vendorMembers &&
                      freelancerList.vendorMembers.length > 0) ||
                    (isHead !== false && !isEmpty(freelanceSubShooterId)) ? (
                      <div className="d-flex flex-row">
                        <Col lg="5" md="5" sm="10" xs="10" className="mt-1">
                          {/* <div className="d-flex justify-content-between">
                            <Label className={"form-label"}>
                              {"Sub Freelancer"}
                            </Label>
                          </div> */}
                          <Select
                            type="text"
                            name="subFreelancerList"
                            value={subFreelancerList}
                            // isMulti
                            onChange={(e) => handleSubFreelanceChange(e)}
                            options={subFreelancerListOptions}
                            placeholder="Select Freelancer"
                            classNamePrefix="select2-selection"
                          />
                        </Col>
                        <Col
                          lg="5"
                          md="5"
                          sm="10"
                          xs="10"
                          className="mt-1 mx-3"
                        >
                          <Input
                            type="text"
                            name="subAmount"
                            value={freelancerData.subAmount}
                            // isMulti
                            onChange={(e) => handleChange(e)}
                            placeholder="Enter Amount"
                          />
                        </Col>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </Row>
              </Modal.Body>

              <Modal.Footer>
                <div>
                  <Button
                    onClick={() => {
                      setFreelancerModal(false)
                      setFreelancerList([])
                      setSubFreelancerList([])
                    }}
                    // style={{ fontSize: "10px", marginLeft: "20px" }}
                    className="btn btn-danger buttons"
                  >
                    {" "}
                    Cancel
                  </Button>
                  <Button
                    onClick={() => {
                      updateFreelancerDetails()
                    }}
                    style={{ marginLeft: "10px" }}
                    className="btn btn-success buttons"
                  >
                    {" "}
                    Update
                  </Button>
                </div>
              </Modal.Footer>
            </Modal>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

FreelancerReport.propTypes = {
  dispatch: PropTypes.func,
  searchProps: PropTypes.func,
  baseProps: PropTypes.any,
  searchBarStyle: PropTypes.any,
  csvProps: PropTypes.any,
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}
const mapStateToProps = () => ({
  //mapstate to props
})

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(FreelancerReport)
)
